import { render, staticRenderFns } from "./role-form.vue?vue&type=template&id=75bab123&scoped=true"
import script from "./role-form.vue?vue&type=script&lang=js"
export * from "./role-form.vue?vue&type=script&lang=js"
import style0 from "./role-form.vue?vue&type=style&index=0&id=75bab123&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bab123",
  null
  
)

export default component.exports